import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../messages/en.json";
import zh from "../messages/zh.json";
import zhTW from "../messages/zh-TW.json";
import ja from "../messages/ja.json";
import ko from "../messages/ko.json";
import th from "../messages/th.json";

export const SUPPORTED_LOCALES = ["en", "zh", "zh-TW", "ja", "ko", "th"] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      "zh-TW": { translation: zhTW },
      ja: { translation: ja },
      ko: { translation: ko },
      th: { translation: th },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
